// Chamadas do Mesa QR. Tudo passa pelo token da mesa: é nele que moram as
// travas (sessão viva, loja aberta, mesa liberada).
import axios from "axios";

const API = "/api";

const erroDe = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail && typeof detail === "object") return detail;
  return { codigo: "ERRO", mensagem: detail || "Não consegui falar com a loja. Tente de novo." };
};

const chamar = async (fn) => {
  try {
    return { ok: true, dados: (await fn()).data };
  } catch (e) {
    return { ok: false, erro: erroDe(e) };
  }
};

export const estadoDaMesa = (token, convite) =>
  chamar(() => axios.get(`${API}/public/mesa/${token}`, { params: convite ? { convite } : {} }));

export const entrarNaMesa = (token) =>
  chamar(() => axios.post(`${API}/public/mesa/${token}/entrar`, {}));

export const identificarPorCpf = (token, { opened_at, cpf, nome, telefone, convite }) =>
  chamar(() => axios.post(`${API}/public/mesa/${token}/identificar`, { opened_at, cpf, nome, telefone, convite }));

// `quem` = { opened_at, cliente_id, chave }: a chave sai do identificar e prova
// que este aparelho é aquele cliente.
export const buscarComanda = (token, quem) =>
  chamar(() => axios.get(`${API}/public/mesa/${token}/comanda`, { params: quem }));

export const verParticipantes = (token, quem) =>
  chamar(() => axios.get(`${API}/public/mesa/${token}/participantes`, { params: quem }));

export const decidirEntrada = (token, quem, alvo_id, aprovar) =>
  chamar(() => axios.post(`${API}/public/mesa/${token}/participantes/decidir`, { ...quem, alvo_id, aprovar }));

export const pedirEntradaDeNovo = (token, quem) =>
  chamar(() => axios.post(`${API}/public/mesa/${token}/participantes/pedir-de-novo`, quem));

// Mudança de mesa (02/10/2026). `minhaMesa` pergunta onde está a sessão que o
// celular guarda (na mesma mesa, ou para qual ela mudou); `mudarDeMesa` leva a
// mesa de `quem` (sessão e chave da mesa `de_token`) para a mesa do `token`.
export const minhaMesa = (token, quem) =>
  chamar(() => axios.get(`${API}/public/mesa/${token}/minha-mesa`, { params: quem }));

export const mudarDeMesa = (token, quem, de_token) =>
  chamar(() => axios.post(`${API}/public/mesa/${token}/mudar`, { ...quem, de_token }));

export const enviarRodada = (token, payload) =>
  chamar(() => axios.post(`${API}/public/mesa/${token}/pedido`, payload));

export const chamarGarcom = (token, opened_at, quem) =>
  chamar(() => axios.post(`${API}/public/mesa/${token}/garcom`, { opened_at, quem }));

// Pagamento pelo celular (24/09/2026). `quem` = { opened_at, cliente_id, chave }.
export const contaDaMesa = (token, quem) =>
  chamar(() => axios.get(`${API}/public/mesa/${token}/conta`, { params: quem }));

// escopo: "meus" | "pessoas" (com `pessoas`) | "mesa"
export const pagarMesa = (token, quem, { escopo, pessoas, usar_cashback }) =>
  chamar(() => axios.post(`${API}/public/mesa/${token}/pagamento`, { ...quem, escopo, pessoas, usar_cashback }));

export const statusPagamento = (token, pagamentoId, quem) =>
  chamar(() => axios.get(`${API}/public/mesa/${token}/pagamento/${pagamentoId}`, { params: quem }));
